import TableCellLink from "ds/components/Table/Row/CellLink";
import TableSimpleCell from "ds/components/TableSimple/Cell";

import { StackPullRequestsTableRunCellProps } from "../types";

const StackPullRequestsTableRunTitleCell = ({
  item: { pullRequest, run },
  stackId,
  ...cellProps
}: StackPullRequestsTableRunCellProps) => {
  return (
    <TableSimpleCell {...cellProps} role="rowheader">
      <TableCellLink
        href={`/stack/${stackId}/run/${run.id}`}
        routerOptions={{ state: { prUrl: pullRequest.url, prTitle: pullRequest.title } }}
      >
        {run.title}
      </TableCellLink>
    </TableSimpleCell>
  );
};

export default StackPullRequestsTableRunTitleCell;
